import { DatasourceMapCharacter, DatasourceMapVenueType } from '@/auto-generated/datasources';
import { GeoJson } from './useMapGeojson';


export type FilterTypeMap = {
  'map-character': DatasourceMapCharacter;
  'map-venue-type': DatasourceMapVenueType;
};
export type FilterTypeKey = keyof FilterTypeMap;
export type FilterType = keyof FilterTypeMap;

export default function useMapFilter(type: FilterType, geoJson: ComputedRef<GeoJson | undefined>) {
  type FilterDatasource = FilterTypeMap[typeof type];
  const activeFilters = ref<FilterDatasource[]>([]);

  const geoJsonFiltered = computed(() => {
    if (!geoJson.value) return undefined;

    const geoJsonData = { ...geoJson.value.data };
    if (activeFilters.value.length > 0) {
      geoJsonData.features = geoJsonData.features.filter((feature) => {
        let prop = '';
        switch (type) {
          case 'map-character':
            prop = 'characters';
            break;
          case 'map-venue-type':
            prop = 'venueType';
            break;
        }
        const propData = feature.properties[prop]?.toString() || undefined;
        for (const filter of activeFilters.value) {
          if (propData == filter) return true;
        }
        return false;
      });
    }
    return {
      ...geoJson.value,
      data: geoJsonData,
    } as GeoJson;
  })

  return {
    activeFilters,
    geoJsonFiltered,
  };
}



// util function to convert strings like map-venue-type to venueType and also convert so we use camelCase instead of kebab-case
export function toDatasourceKey(filter: FilterType) {
  return filter.split('map-').pop()?.replace(/-/g, '') as string;
}

